/* Carlota Maré · CRO otoño (13-oct-2026): buscador con "Lo más vendido", enlaces de ayuda en el menú móvil,
   "Guía de tallas" en la línea de la palabra Talla y pie en desplegables en el móvil. Sin librerías ni apps. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* 1) Buscador: al abrirlo sin escribir, 6 "Más vendidas" (colección real mas-vendidos, ordenada por ventas).
        Se piden una sola vez con la Section Rendering API; al escribir manda la búsqueda predictiva del tema. */
  let suggHtml = null;
  let suggLoading = null;
  function loadSugg() {
    if (suggHtml !== null) return Promise.resolve(suggHtml);
    if (!suggLoading) {
      suggLoading = fetch(root + 'collections/mas-vendidos?section_id=cm-search-suggest')
        .then((r) => (r.ok ? r.text() : ''))
        .then((t) => { suggHtml = t; return t; })
        .catch(() => { suggHtml = ''; return ''; });
    }
    return suggLoading;
  }
  function initSearch() {
    document.querySelectorAll('details-modal.header__search details').forEach((det) => {
      if (det.dataset.cmSugg) return;
      det.dataset.cmSugg = '1';
      const content = det.querySelector('.search-modal__content');
      const input = det.querySelector('input[type="search"]');
      if (!content || !input) return;
      const wrap = document.createElement('div');
      wrap.className = 'cm-sugg-wrap';
      wrap.hidden = true;
      content.appendChild(wrap);
      const sync = () => {
        const empty = input.value.trim() === '';
        if (!det.open || !empty || !wrap.innerHTML.trim()) { wrap.hidden = true; return; }
        wrap.hidden = false;
      };
      const open = () => {
        loadSugg().then((html) => {
          if (html && !wrap.innerHTML.trim()) wrap.innerHTML = html;
          sync();
        });
      };
      det.addEventListener('toggle', () => (det.open ? open() : sync()));
      input.addEventListener('input', sync);
      input.addEventListener('focus', open);
      if (det.open) open();
    });
  }

  /* 2) Menú móvil: ayuda abajo y en pequeño (no compite con las categorías). */
  function initDrawer() {
    const nav = document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (!nav || nav.querySelector('.cm-drawer-extra')) return;
    const ul = document.createElement('ul');
    ul.className = 'cm-drawer-extra';
    [
      ['Seguir pedido', 'apps/parcelpanel'],
      ['Envíos y devoluciones', 'pages/politica-de-envios'],
      ['Contacto', 'pages/contact'],
    ].forEach(([t, u]) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = root + u;
      a.textContent = t;
      li.appendChild(a);
      ul.appendChild(li);
    });
    nav.appendChild(ul);
  }

  /* 3) Ficha: "Guía de tallas" en la misma línea que "Talla". El tema vuelve a pintar el selector al cambiar
        de color, así que se recoloca con un MutationObserver. */
  const SIZE_RE = /talla|size|medida/i;
  function sizeTable() {
    const box = document.getElementById('cm-tabla-tallas');
    if (!box) return null;
    const head = Array.from(box.querySelectorAll('h2,h3,h4,p strong')).find((h) => /tallas/i.test(h.textContent));
    return head || box.querySelector('table') || box;
  }
  function placeGuide() {
    const main = document.querySelector('main[data-template="product"]');
    if (!main || !sizeTable()) return;
    const fs = Array.from(main.querySelectorAll('variant-selects fieldset')).find((f) => {
      const l = f.querySelector('legend');
      return l && SIZE_RE.test(l.textContent);
    });
    const legend = fs && fs.querySelector('legend');
    if (!legend || legend.querySelector('.cm-guide-top')) return;
    legend.classList.add('cm-legend-guide');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cm-guide-top';
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M6 7v3M10 7v4M14 7v3M18 7v4"/></svg>Guía de tallas';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const t = sizeTable();
      if (!t) return;
      t.style.scrollMarginTop = '9rem'; // que no quede debajo de la cabecera fija
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    legend.appendChild(btn);
  }
  function initGuide() {
    const main = document.querySelector('main[data-template="product"]');
    if (!main) return;
    placeGuide();
    let raf = 0;
    new MutationObserver(() => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; placeGuide(); });
    }).observe(main, { childList: true, subtree: true });
  }

  /* 4) Pie en desplegables en el móvil (los bloques de enlaces; el texto de la marca queda abierto). */
  function initFooter() {
    const footer = document.querySelector('.footer');
    if (!footer || footer.classList.contains('cm-foot-acc')) return;
    const blocks = Array.from(footer.querySelectorAll('.footer-block')).filter(
      (b) => b.querySelector('.footer-block__heading') && b.querySelector('ul.footer-block__details-content')
    );
    if (!blocks.length) return;
    footer.classList.add('cm-foot-acc');
    blocks.forEach((b) => {
      b.classList.add('cm-acc-block');
      const h = b.querySelector('.footer-block__heading');
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      const toggle = () => {
        if (window.innerWidth >= 750) return;
        const open = b.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  const start = () => { initSearch(); initDrawer(); initGuide(); initFooter(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
